<template>
  <div class="container-fluid py-4">
    <div class="card">
      <div class="card-header bg-light">
        <h5 class="card-title mb-0">Мониторинг</h5>
      </div>
      <div class="card-body">
        <p class="text-muted">
          Внеплановый запуск — то же, что делают расписания. Сообщения приходят во внутренние пинг-каналы Telegram.
          <a href="https://bik.planfix.ru/task/189850" target="_blank" rel="noopener">How it works</a>
        </p>

        <div class="d-flex flex-column gap-3" style="max-width: 640px">
          <h6 class="mb-0 mt-2">Информер</h6>
          <div v-for="action in actions" :key="action.key" class="border rounded p-3">
            <div class="d-flex justify-content-between align-items-center gap-3">
              <div>
                <div class="fw-semibold">{{ action.title }}</div>
                <div class="small text-muted">{{ action.description }}</div>
              </div>
              <button
                  class="btn btn-primary text-nowrap"
                  :disabled="busy[action.key]"
                  @click="run(action.key, action.call)">
                <span v-if="busy[action.key]" class="spinner-border spinner-border-sm me-1"></span>
                Запустить
              </button>
            </div>
            <div v-if="results[action.key]" class="small mt-2" :class="results[action.key].ok ? 'text-success' : 'text-danger'">
              {{ results[action.key].text }}
            </div>
          </div>

          <h6 class="mb-0 mt-3">Бэкапы</h6>
          <div class="small text-muted">
            Задачи встают в очередь и выполняются по одной. Если бэкап за сегодня уже есть, он пропускается.
          </div>

          <div class="border rounded p-3">
            <div class="d-flex justify-content-between align-items-center gap-3">
              <div>
                <div class="fw-semibold">Все проекты</div>
                <div class="small text-muted">Бэкапы всех настроек всех проектов.</div>
              </div>
              <button
                  class="btn btn-primary text-nowrap"
                  :disabled="busy.all"
                  @click="confirmAll">
                <span v-if="busy.all" class="spinner-border spinner-border-sm me-1"></span>
                Запустить все
              </button>
            </div>
            <div v-if="results.all" class="small mt-2" :class="results.all.ok ? 'text-success' : 'text-danger'">
              {{ results.all.text }}
            </div>
          </div>

          <div class="border rounded p-3">
            <div class="fw-semibold mb-2">Один проект</div>
            <div class="d-flex gap-2">
              <select v-model="projectId" class="form-select">
                <option :value="null" disabled>Выберите проект</option>
                <option v-for="project in projectStore.items" :key="project.id" :value="project.id">
                  {{ project.name }}
                </option>
              </select>
              <button
                  class="btn btn-primary text-nowrap"
                  :disabled="!projectId || busy.project"
                  @click="run('project', () => monitorStore.runProjectBackups(projectId), backupsResult)">
                <span v-if="busy.project" class="spinner-border spinner-border-sm me-1"></span>
                Запустить
              </button>
            </div>
            <div v-if="results.project" class="small mt-2" :class="results.project.ok ? 'text-success' : 'text-danger'">
              {{ results.project.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {useMonitorStore} from "@/store/monitor";
import {useProjectStore} from "@/store/projects";

const monitorStore = useMonitorStore()
const projectStore = useProjectStore()

const actions = [
  {
    key: 'ping',
    title: 'Проверка доступности',
    description: 'Ежечасная проверка сейчас: сайты и API, перезапуск упавших баз и Node-приложений у клиентов.',
    call: () => monitorStore.pingReport(),
  },
  {
    key: 'report',
    title: 'Сводка по бэкапам',
    description: 'Ежедневная сводка сейчас: итог ночного обхода, копии по проектам, свободное место, нарушения правил.',
    call: () => monitorStore.backupReport(),
  },
]

const busy = reactive({})
const results = reactive({})
const projectId = ref(null)

onMounted(() => projectStore.getList())

// «Запущено 3 · пропущено 1 — уже есть за сегодня · ошибок 0»
function backupsResult(data) {
  const parts = [`Запущено ${data.started} из ${data.total}`]
  if (data.skipped) parts.push(`пропущено ${data.skipped} — уже есть за сегодня`)
  if (data.failed) parts.push(`не запустилось ${data.failed} — см. журнал`)
  return {ok: !data.failed, text: parts.join(' · ')}
}

function confirmAll() {
  if (confirm('Запустить бэкапы всех проектов? Они пойдут по очереди и займут время.')) {
    run('all', () => monitorStore.runAllBackups(), backupsResult)
  }
}

async function run(key, call, format) {
  busy[key] = true
  results[key] = null
  try {
    const data = await call()
    results[key] = format
        ? format(data)
        : {ok: data?.started !== false, text: data?.message ?? 'Запущено'}
  } catch (error) {
    results[key] = {ok: false, text: `Не удалось запустить: ${error?.response?.status ?? error.message}`}
  } finally {
    busy[key] = false
  }
}
</script>
